import { CropCircle } from "./CropCircle";
import { classes } from "./react";

export type CropLabelProps = {
    /**
     * Additional `className` for the component.
     */
    className?: string;
    /**
     * Event handler fired when the component is clicked.
     */
    onClick?: React.MouseEventHandler<HTMLSpanElement>;
    /**
     * The background color of the crop circle.
     */
    color: React.CSSProperties["backgroundColor"];
    /**
     * The name of the crop, to display as a tooltip. (if `children` are not specified)
     */
    title?: string;
    /**
     * The name of the crop, to display as a tooltip.
     */
    children?: React.ReactNode;
};

/**
 * Combines a `CropCircle` with a text label.
 */
export function CropLabel({ title, children = title, className, color, onClick }: CropLabelProps) {
    return (
        <span className={classes("crop-label", className)} onClick={onClick}>
            <CropCircle className="crop-label--crop-circle" color={color} />
            <span className="crop-label--description">{children}</span>
        </span>
    );
}
